import React from 'react';
import { Grid } from '@mui/material';

import {
	ModuleSearchField,
	SearchSelectField,
	SimpleTextField,
	DateField,
	useSettings,
	Utils
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function RequestsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	function autoUpdateDateTo(newStatus) {
		if ([3, 100].includes(newStatus?.prst_id) && !props.model.proj_d_to) {
			props.sendChange('proj_d_to', Utils.today());
		}
	}

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TITLE */}
				<SimpleTextField
					name="reqs_title"
					label={t('DETAILS_REQUESTS_FIELD_TITLE')}
					value={props.model.reqs_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* STATUS */}
				<SearchSelectField
					name="reqs_rqst_id"
					label={t('DETAILS_REQUESTS_FIELD_STATUS')}
					value={props.model.reqs_rqst_id}
					systable="requests_statuses"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					afterChange={autoUpdateDateTo}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="reqs_rqty_id"
					label={t('DETAILS_REQUESTS_FIELD_TYPE')}
					value={props.model.reqs_rqty_id}
					systable="requests_types"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* SIGNALLER USER */}
				<ModuleSearchField
					name="reqs_user_signaller_uid"
					label={t('DETAILS_REQUESTS_FIELD_SIGNALLER_USER')}
					module="users"
					uid={props.model.reqs_user_signaller_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER */}
				<ModuleSearchField
					name="reqs_user_assigned_uid"
					label={t('DETAILS_REQUESTS_FIELD_ASSIGNED_USER')}
					module="users"
					uid={props.model.reqs_user_assigned_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DATE FROM */}
				<DateField
					name="reqs_d_from"
					label={t('DETAILS_REQUESTS_FIELD_DATE_FROM')}
					value={props.model.reqs_d_from}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DATE TO */}
				<DateField
					name="reqs_d_to"
					label={t('DETAILS_REQUESTS_FIELD_DATE_TO')}
					value={props.model.reqs_d_to}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* USER CLOSED */}
				<ModuleSearchField
					module="users"
					name="reqs_user_closed_uid"
					label={t('DETAILS_REQUESTS_FIELD_USER_CLOSED')}
					uid={props.model.reqs_user_closed_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* CLOSED REASON */}
				<SimpleTextField
					name="reqs_closed_reason"
					label={t('DETAILS_REQUESTS_FIELD_CLOSED_REASON')}
					value={props.model.reqs_closed_reason}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
